/**
 * JoinSLSiteHeaderLanguagesView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait JoinSLSiteHeaderLanguages
 */

import { useJoinSLSiteHeaderLanguagesLogic } from '@/hooks/traits/useJoinSLSiteHeaderLanguagesLogic';
import type { JoinSLSiteHeaderLanguagesConfig } from '@/hooks/traits/useJoinSLSiteHeaderLanguagesLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { JoinSLJoinView as JoinSLJoinViewEntity } from '@app/shared';
import { Button } from '@almadar/ui/components';
import { Menu } from '@almadar/ui/components';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';
import { useTranslate } from '@almadar/ui/hooks';

interface JoinSLSiteHeaderLanguagesViewProps {
  config?: Partial<JoinSLSiteHeaderLanguagesConfig>;
}

export function JoinSLSiteHeaderLanguagesView({ config: propsConfig }: JoinSLSiteHeaderLanguagesViewProps) {
  const { t: __t, locale: __locale } = useTranslate();
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useJoinSLSiteHeaderLanguagesLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['JoinSLJoinView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="JoinSL" trait="JoinSLSiteHeaderLanguages">
      {slotWriter['main'] === 'INIT' ? (<Menu items={Array.isArray(([{ code: "en" as const, label: "English" as const, href: "/join" as const }, { label: "العربية" as const, href: "/ar/join" as const, code: "ar" as const }, { label: "Slovenščina" as const, code: "sl" as const, href: "/sl/join" as const }]).map((entry) => ({ label: (getNestedValue(entry, "label") ?? ""), icon: (((getNestedValue(entry, "code") ?? "") === __locale) ? "check" : ""), id: (getNestedValue(entry, "code") ?? ""), href: (getNestedValue(entry, "href") ?? "") }))) ? (((([{ code: "en" as const, label: "English" as const, href: "/join" as const }, { label: "العربية" as const, href: "/ar/join" as const, code: "ar" as const }, { label: "Slovenščina" as const, code: "sl" as const, href: "/sl/join" as const }]).map((entry) => ({ label: (getNestedValue(entry, "label") ?? ""), icon: (((getNestedValue(entry, "code") ?? "") === __locale) ? "check" : ""), id: (getNestedValue(entry, "code") ?? ""), href: (getNestedValue(entry, "href") ?? "") }))) as EntityRow[]) as ({ badge?: string | number; disabled?: boolean; event?: string; href?: string; icon?: string; id?: string; label: string; onClick?: never; subMenu?: never[]; title?: string; type?: 'item' | 'divider'; url?: string; variant?: 'default' | 'danger' })[]) : []} className={((([{ label: "English" as const, href: "/join" as const, code: "en" as const }, { code: "ar" as const, href: "/ar/join" as const, label: "العربية" as const }, { code: "sl" as const, href: "/sl/join" as const, label: "Slovenščina" as const }]).length === 0)) ? "hidden" : ""} trigger={<Button variant="ghost" label={String(__locale.toUpperCase())} size="sm" icon="globe" />} position="bottom-end" />) : null}
    </TraitScopeProvider>
  );
}

export default JoinSLSiteHeaderLanguagesView;
